import api from "./api";
import { API_ENDPOINTS } from "./apiEndPoints";

type NetworkActualChannel = {
  defaultCh: number;
};

let inFlightDefaultChannelsRequest: Promise<number[]> | null = null;

export const getBreakinDefaultChannels = (): Promise<number[]> => {
  if (!inFlightDefaultChannelsRequest) {
    inFlightDefaultChannelsRequest = api<NetworkActualChannel[] | null>(
      "get",
      API_ENDPOINTS.GET_NETWORK_CHANNELS,
      null,
      {
        showGlobalLoader: false,
      },
    )
      .then((response) =>
        (response ?? [])
          .map((item) => item.defaultCh)
          .filter((value, index, channels) => Number.isFinite(value) && channels.indexOf(value) === index)
          .sort((left, right) => left - right),
      )
      .finally(() => {
        inFlightDefaultChannelsRequest = null;
      });
  }

  return inFlightDefaultChannelsRequest;
};
